
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Redirect, useParams } from 'react-router';

import { useStore } from 'stores';
import * as paths from 'app-router/paths';
import Loading from 'components/Loading';
import { ErrorMessage } from 'components/Message';
import { LabeledIcon, ReloadIcon } from 'components/Icon';
import { FormCard } from 'components/Card';

import { EditForm, UserInputDictionary } from './EditForm';

export const Page: React.FC = observer(() =>
{
  const [needToLoad, setNeedToLoad] = useState(true);
  const { featureToken } = useParams<{featureToken: string}>();
  const { uiStore, featureStore } = useStore();
  const [userInput, setUserInput] = useState<UserInputDictionary>({});

  const reloadDataHandler = async () => await featureStore.getByTokenAsync(featureToken);

  useEffect(() =>
  {
    if (!featureStore.feature || featureStore.feature.token !== featureToken)
    {
      featureStore.getByTokenAsync(featureToken);
    }
    setNeedToLoad(prev => false);
  }, [featureToken, featureStore, setNeedToLoad]);

  return (
    <article className="page feature-edit">
      <FormCard>
      {
        featureStore.isLoading || needToLoad
        ? <><h1>{uiStore.labels.common.loading}</h1><Loading /></>
        : featureStore.isError
          ? <>
              <h1>{uiStore.labels.common.anErrorOccured}</h1>
              <ErrorMessage>{featureStore.errorMessage} <button onClick={reloadDataHandler}><LabeledIcon label={uiStore.labels.common.tryAgain}><ReloadIcon/></LabeledIcon></button></ErrorMessage>
            </>
          : featureStore.feature
            ? <>
                <h1>{uiStore.labels.pages.features.pages.featureEdit.title.apply({featureName: featureStore.feature.name})}</h1>
                {featureStore.errorMessage ? <ErrorMessage>{featureStore.errorMessage}</ErrorMessage> : null}
                <EditForm userInput={userInput} saveUserInput={(input) => setUserInput(prev => input)} feature={featureStore.feature} />
              </>
            : <Redirect to={paths.buildNotFoundPath()} />
      }
      </FormCard>
    </article>
  );
});